import { render, staticRenderFns } from "./PanelNoveltyBox.vue?vue&type=template&id=22102b65&scoped=true&"
var script = {}
import style0 from "./PanelNoveltyBox.vue?vue&type=style&index=0&id=22102b65&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22102b65",
  null
  
)

export default component.exports